export default __webpack_public_path__ + "images/0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111.png";